import { useInvalidate } from '@refinedev/core'
import { useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { productCatalogCreateProductMutation, type ProductListingCreateRoot } from '@repo/sdk'

interface UseCreateProductReturn {
  createProduct: (body: ProductListingCreateRoot) => void
  isPending: boolean
}

export function useCreateProduct(onSuccess: () => void): UseCreateProductReturn {
  const invalidate = useInvalidate()
  const { message } = App.useApp()
  const { t } = useTranslation()

  const { mutate, isPending } = useMutation({
    ...productCatalogCreateProductMutation(),
    onSuccess: async () => {
      message.success(t('pages.products.messages.createSuccess'))
      // refine keys product queries as ['data','default','product-list', …]:
      // a raw ['product-list'] key never matched, so the list stayed stale.
      await invalidate({ resource: 'product-list', invalidates: ['list'] })
      onSuccess()
    },
    onError: () => {
      message.error(t('pages.products.messages.createFailed'))
    },
  })

  const createProduct = (body: ProductListingCreateRoot) => {
    mutate({ body })
  }

  return { createProduct, isPending }
}
